module.exports = __webpack_public_path__ + "static/img/advertising04@tw.9de9353.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/discover/advertising04@tw.jpg
// module id = 9MJW
// module chunks = 0